module.exports = __webpack_public_path__ + "img/70.09c38ce1.jpg";